import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
  selector: '[viewEdit]',
  exportAs: "viewEdit",
  host: {
    '[style.width]': '"inherit"',
  }
})
export class ViewEditDirective implements AfterViewInit,OnChanges{
  @Input() initialState:string;//Whether the search container is expanded or not. false == collapsed
  private isEditSubject = new BehaviorSubject(null);
  isEditSubject$ = this.isEditSubject.pipe();
  view:ElementRef;
  edit:ElementRef;  

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["initialState"]){
      console.log("InitialState in ViewEditDirective",this.initialState)
      if(this.initialState == "edit"){
        console.log("Setting to edit",this.initialState);
        this.isEditSubject.next(true);
      }else{
        console.log("Setting to view",this.initialState)
        this.isEditSubject.next(false);
      }
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    setTimeout(() => {
      this.view = this.el.nativeElement.querySelector("div.view");
      this.edit = this.el.nativeElement.querySelector("div.edit");
      //this.toggle();
    },1000)
  }

  /* setInitialState(view:ElementRef,edit:ElementRef):void{
    let classes = edit.nativeElement.classList;
    if(classes.contains('view-edit-show')){
      this.isEditSubject.next(true)
    }else{
      this.isEditSubject.next(false)
    }
  } */

  toggle():void{
    this.isEditSubject?.getValue() ? this.hideEdit() : this.showEdit();
  }

  showEdit(){
    this.renderer.addClass(this.edit,"view-edit-show");
    this.renderer.removeClass(this.edit,"view-edit-hide");
    this.renderer.addClass(this.view,"view-edit-hide");
    this.renderer.removeClass(this.view,"view-edit-show");
    this.isEditSubject.next(true);
  }
  hideEdit(){
    this.renderer.addClass(this.edit,"view-edit-hide");
    this.renderer.removeClass(this.edit,"view-edit-show");
    this.renderer.addClass(this.view,"view-edit-show");
    this.renderer.removeClass(this.view,"view-edit-hide");
    this.isEditSubject.next(false);
  }

}
